export default {
  methods: {
    getEmployeeRecords () {
      var pageUrl = ''
      pageUrl += 'staff?all=all&status=active'
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      this.$axios
      .get(`${pageUrl}`, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      .then((response) => response.data)
      .then((data) => {
        this.staffs = data.data
        _.forEach(this.staffs, function (item, key) {
          this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
          if (this.form.employee_id === item.user.id) {
            this.staf = item
          }
        }.bind(this))
      })
    .catch(
      function (error) {
        Toast.fire({ icon: 'error', title: 'Please Try Again' })
        this.form.errors.errors = error.response.data.error
      }.bind(this)
    )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/EmployeeRecords.js